import { navigation } from '../../../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		textAlign: 'center',
	},
	input: {
		marginBottom: 30,
	},
	label: {
		color: navigation,
		fontSize: 14,
		marginBottom: 6,
		textAlign: 'left',
	},
	logo: {
		height: 'auto',
		margin: '0 auto 30px auto',
		width: 150,
	},
	modal: {},
	signInButton: {
		margin: 'auto',
	},
});
